import React from 'react';

export type TwoColCard = {
  label: string;
  abbr?: string;
  description: string;
  pointsHeading?: string;
  points: string[];
};

type Props = {
  eyebrow: string;
  heading: string;
  body: string;
  cards: [TwoColCard, TwoColCard];
  footer?: string;
};

const TwoColCardsSection: React.FC<Props> = ({ eyebrow, heading, body, cards, footer }) => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <div className="mb-6">
        <p className="text-sm font-medium uppercase tracking-widest text-brandGreen mb-3">{eyebrow}</p>
        <h2 className="text-pureWhite font-medium tracking-tight max-w-3xl">{heading}</h2>
        <p className="text-pureWhite/80 mt-4 max-w-3xl leading-relaxed">{body}</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        {cards.map((card) => (
          <Card key={card.label} {...card} />
        ))}
      </div>

      {footer && (
        <p className="text-pureWhite/60 text-base leading-relaxed max-w-3xl mt-6">{footer}</p>
      )}
    </div>
  );
};

const Card: React.FC<TwoColCard> = ({ label, abbr, description, pointsHeading = 'Use when', points }) => {
  return (
    <div className="border-1 border-pureWhite/20 rounded-2xl p-5 bg-pureWhite/5">
      <div className="flex items-baseline gap-3 mb-3">
        <h3 className="text-pureWhite font-medium">{label}</h3>
        {abbr && <span className="text-xs font-mono text-brandGreen tracking-widest">{abbr}</span>}
      </div>
      <p className="text-pureWhite/80 leading-relaxed mb-4">{description}</p>
      <div className="border-t border-pureWhite/10 pt-4">
        <p className="text-xs uppercase tracking-widest text-pureWhite/60 mb-2">{pointsHeading}</p>
        <ul className="space-y-2">
          {points.map((item) => (
            <li key={item} className="text-pureWhite/90 text-base leading-snug flex gap-2">
              <span className="text-brandGreen mt-2 shrink-0 block w-2 h-2 rounded-full" aria-hidden="true" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

TwoColCardsSection.displayName = 'TwoColCardsSection';
export default TwoColCardsSection;
